import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet} from 'react-native';

export default (props: ITheme) =>
  StyleSheet.create({
    buttonStyle: {
      width: 35,
      height: 35,
    },
    imageStyle: {
      width: 35,
      height: 35,
    },
  });
